import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from 'store/slices/authSlice';
import TimedRedirect from 'components/layout/TimedRedirect/TimedRedirect';

export default function Logout() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  return (
    <div className="flex min-h-screen flex-col justify-center px-6 py-12 lg:px-8 bg-gray-900">
      <TimedRedirect 
        url="/login" 
        message="You have been logged out. Redirecting to login..." 
        delay={4000} 
      />
    </div>
  );
}
